module.exports = __webpack_public_path__ + "media/images/vector-9@2x-4854e3b637284b5f933771805c55b244.png";